import { Card } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";
import { useTranslation } from 'react-i18next';

const TestimonialsSection = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      name: t('testimonials.items.client1.name'),
      role: t('testimonials.items.client1.role'),
      content: t('testimonials.items.client1.content'),
      rating: 5
    },
    {
      name: t('testimonials.items.client2.name'),
      role: t('testimonials.items.client2.role'),
      content: t('testimonials.items.client2.content'),
      rating: 5
    },
    {
      name: t('testimonials.items.client3.name'),
      role: t('testimonials.items.client3.role'),
      content: t('testimonials.items.client3.content'),
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-20 px-6 relative">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4 text-glow-cyber">
            <span className="bg-gradient-cyber bg-clip-text text-transparent">
              {t('testimonials.title')}
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {t('testimonials.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="glass p-8 border-glow hover-glow relative">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-cyber-blue/30" />
              
              <div className="flex gap-1 mb-4">
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-cyber-orange text-cyber-orange" />
                ))}
              </div>
              
              <p className="text-muted-foreground mb-6 leading-relaxed italic">
                "{testimonial.content}"
              </p>
              
              <div className="border-t border-border/20 pt-4">
                <p className="font-semibold">{testimonial.name}</p>
                <p className="text-sm text-muted-foreground">{testimonial.role}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
